import React from 'react';
import HeroImage from "../assets/HopcomsHeroImg.jpeg";
import Paytm from "../assets/Paytm.jpeg";
import Ola from "../assets/Ola.jpeg";
import Mappls from "../assets/Mappls.jpeg";
import Nstore from '../assets/Nstore.jpeg';
import MyStore from '../assets/MyStore.jpeg';
import NearShop from '../assets/NearShop.jpeg';
import PickApp from '../assets/PickApp.jpg';
import Search from '../assets/Search.jpg';
import HomeDelivery from '../assets/HomeDelivery.jpg';
import {CardContent, CardMedia, Box, Grid,Card} from '@mui/material';
import {Link} from 'react-router-dom'

export default function Hopcoms() {
  return (
    <>
        <Box
            component="img"
            sx={{
                width: '100%',
                maxHeight: { lg: '80vh', md: '70vh', sm:'60vh', xs:'40vh'},
                padding:'2%'
            }}
            alt="Hero-img"
            src={HeroImage}
            />
        <Box className="container1">
            <Box className="inner-container">
                <Box className="bar" />
                <p className="text" >
                    Choose a Buyer Application
                </p>
            </Box>
            <Box className="divider" />
            <Grid container rowSpacing={{lg:8, md:6, sm:4, xs:4}} sx={{justifyContent:'center', paddingBottom:'5%'}}>
                <Grid item lg={2.4} md={2.4} sm={2.4} xs={6}>
                    <Card className='ns-card'>
                            <CardMedia
                                className='ns-card-img'
                                component="img"
                                image={Paytm}
                                alt="green iguana"
                            />
                            <CardContent>
                            <Link className='shop-now' to='https://paytmmall.com/ondc/sellerlisting-storefront/123456?sfId=ondc-new-hp' target='_blank'>
                                Shop Now
                            </Link>
                            </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={2.4} md={2.4} sm={2.4} xs={6}>
                    <Card className='ns-card'>
                            <CardMedia
                                className='ns-card-img'
                                component="img"
                                image={Ola}
                                alt="green iguana"
                            />
                            <CardContent>
                            <Link className='shop-now' to='https://play.google.com/store/apps/details?id=com.olacabs.customer' target='_blank'>
                                Shop Now
                            </Link>
                            </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={2.4} md={2.4} sm={2.4} xs={6}>
                    <Card className='ns-card'>
                            <CardMedia
                                className='ns-card-img'
                                component="img"
                                image={Mappls}
                                alt="green iguana"
                            />
                            <CardContent>
                            <Link className='shop-now' to='https://mappls.com/mall/ondc/' target='_blank'>
                                Shop Now
                            </Link>
                            </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={2.4} md={2.4} sm={2.4} xs={6}>
                    <Card className='ns-card'>
                            <CardMedia
                                sx={{ border:'0.2px solid #E8E8E8'}}
                                className='ns-card-img'
                                component="img"
                                image={Nstore}
                                alt="green iguana"
                            />
                            <CardContent>
                            <Link className='shop-now' to='https://ondc.nlincs.in/' target='_blank'>
                                Shop Now
                            </Link>
                            </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={2.4} md={2.4} sm={2.4} xs={6}>
                    <Card className='ns-card'>
                            <CardMedia
                                className='ns-card-img'
                                component="img"
                                image={MyStore}
                                alt="green iguana"
                            />
                            <CardContent>
                            <Link className='shop-now' to='https://www.mystore.in/en/' target='_blank'>
                                Shop Now
                            </Link>
                            </CardContent>
                    </Card>
                </Grid>
                <Grid item lg={2.4} md={2.4} sm={2.4} xs={6}>
                    <Card className='ns-card'>
                            <CardMedia
                                className='ns-card-img'
                                component="img"
                                image={NearShop}
                                alt="green iguana"
                            />
                            <CardContent>
                            <Link className='shop-now' to='https://play.google.com/store/apps/details?id=com.imss.nsbap' target='_blank'>
                                Shop Now
                            </Link>
                            </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container className='footer-card'>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box className="inner-container" sx={{marginTop:'25px'}} >
                        <Box className="footer-bar" />
                        <p className="footer-text" >
                            How To Shop
                        </p>
                    </Box>
                </Grid>
                <Grid container className='bt-sp' rowSpacing={{lg:8, md:6, sm:4, xs:3}} >
                    <Grid item lg={4} md={4} sm={4} xs={12} className='footer-section'>
                        <img src={PickApp} alt='Mobile-img' className='footer-img' />
                        <p className="footer-subtitle">
                            Pick a buyer app from the list provided
                        </p>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12} className='footer-section'>
                        <img src={Search} alt='Search-img' className='footer-img' />
                        <p className="footer-subtitle">
                            Search for Hopcoms stores
                        </p>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12} className='footer-section'>
                        <img src={HomeDelivery} alt='Home-Delivery-img' className='footer-img' />
                        <p className="footer-subtitle">
                            Place order & Get it home delivered
                        </p>
                    </Grid>
                </Grid>
            </Grid>
            <br></br>
        </Box>
        
    </>
  )
}
